import { ChatCircle } from "@phosphor-icons/react";
import { ConsumerBrandMetrics } from "@/components/ai-consumer-research/overview/metrics";
import { SentimentTrendOverview } from "@/components/ai-consumer-research/overview/sentiment-trend";
import { TopConsumerThemes } from "@/components/ai-consumer-research/overview/top-consumer-themes";
import { ChannelMix } from "@/components/ai-consumer-research/overview/channel-mix";
import { SubBrandPerformance } from "@/components/ai-consumer-research/overview/sub-brand-performance";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/overview")({
  component: Overview,
});

export function Overview() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <span className="flex size-9 items-center justify-center rounded-lg bg-muted">
        <ChatCircle className="size-5" weight="bold" />
        </span>
        <h2 className="text-2xl font-semibold">Consumer Research</h2>
      </div>
      <ConsumerBrandMetrics />
      <SentimentTrendOverview />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TopConsumerThemes />
        <ChannelMix />
      </div>
      <SubBrandPerformance />
    </div>
  );
}
